import React, { FC, useEffect, useState } from 'react';
import { formatFilterPrice, Icon, IconEnum, isTouchDevice } from '@investoro/core';
import styled from 'styled-components';

import { TabType } from 'components/common/Tabs/V2Tabs';
import Tooltip from 'components/common/Tooltip/Tooltip';

const GeneratedInfoContainer = styled.div<{ isInModal?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 6px;

    ${({ isInModal }) => isInModal &&
        `
        flex-direction: row;
    `}

`;

const BoxWrapper = styled.div<{ isAiColor?: boolean }>`
    border-radius: 8px;
    cursor: ${(props) => props.isAiColor ? 'normal' : 'pointer'};
    padding: 6px 12px;
    background-color: ${(props) => props.isAiColor ? 'var(--background-color-ai)' : 'var(--label-color-light)'};
    display: flex;
    flex-direction: column;

    span {
        font-size: 12px;
        font-weight: 300;
        font-style: italic;
    }

    img {
        height: ${(props) => props.isAiColor ? '18px' : '14px'};
    }

    @media (max-width: 489px) {
        flex-direction: row;
        justify-content: space-between;
    }
    
`;

const DisplayedValue = styled.div<{ blur?: boolean }>`
    font-weight: 600;
    text-align: right;
    transition: filter 0.3s ease;
    user-select: none;
    filter: ${({ blur }) => blur ? 'blur(3px)' : 'none'};
`;

const Title = styled.div`
    display: flex;
    font-style: italic;
    justify-content: flex-end;
    font-weight:300;
    gap: 5px;
`;

interface PredicetdPriceAndCalculationContainerProps {
    predictedPrice?: string;
    calculationValue?: string;
    isInModal?: boolean;
    openOfferTab?: (tab: TabType) => void;
    hasCalculationRole?: boolean;
    hasPredictionRole?: boolean;
}

const PredicetdPriceAndCalculationContainer: FC<PredicetdPriceAndCalculationContainerProps> = ({ predictedPrice, calculationValue, isInModal, openOfferTab, hasCalculationRole, hasPredictionRole }) => {
    const [showCalculationTooltip, setShowCalculationTooltip] = useState(false);
    const [calculationRef, setCalculationRef] = useState<HTMLElement | null>(null);

    const handleCalculationToggle = (e: React.MouseEvent | React.TouchEvent) => {
        e.stopPropagation();

        if (isTouch) setShowCalculationTooltip((prev) => !prev);

        if (openOfferTab) {
            openOfferTab(TabType.CALCULATIONS);
        }
    };

    const [isTouch, setIsTouch] = useState(false);

    useEffect(() => {
        setIsTouch(isTouchDevice());
    }, []);

    if (!calculationValue && !predictedPrice) return null;

    const calculationTooltipText = <>
        <p>Dane wygenerowane na podstawie obliczeń kalkulatora</p>
        <p>{!hasCalculationRole && 'Opcja niedostępna w Twoim pakiecie'}</p>
    </>;

    return (
        <GeneratedInfoContainer isInModal={isInModal}>
            {predictedPrice && <BoxWrapper isAiColor>
                <Title role="heading" aria-label="Cena wg AI">
                    Cena wg AI <Icon icon={IconEnum.AI_STARS} />
                </Title>
                <DisplayedValue blur={!hasPredictionRole}>{predictedPrice ? ` ${formatFilterPrice(predictedPrice)} zł` : null}</DisplayedValue>
            </BoxWrapper>}
            {calculationValue && <BoxWrapper
                ref={setCalculationRef}
                onClick={handleCalculationToggle}
                onMouseEnter={() => !isTouch && setShowCalculationTooltip(true)}
                onMouseLeave={() => !isTouch && setShowCalculationTooltip(false)}>
                <Title role="heading" aria-label="Zakup MAX">
                    Zakup MAX <Icon icon={IconEnum.CALCULATOR} />
                </Title>
                <DisplayedValue blur={!hasCalculationRole}>{`${formatFilterPrice(calculationValue)} zł`}</DisplayedValue>
                <Tooltip
                    referenceElement={calculationRef}
                    showTooltip={showCalculationTooltip}
                    text={calculationTooltipText}
                />
            </BoxWrapper>}
        </GeneratedInfoContainer>
    );
};

export default PredicetdPriceAndCalculationContainer;
